
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Breadcrumbs, Card, Grid, Link, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import Avatar from '@mui/material/Avatar';
import { default as React } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { myProfileAction } from '../../redux/toolkit/profile/my-profile'
import CardContent from '@mui/material/CardContent';
import WhatsAppIcon from '../../assets/img/whatsapp.png';
import CallIcon from '../../assets/img/Call.png';
import emailLink from '../../assets/img/emaillink.png';


const breadcrumb = (
    <Stack spacing={2} >
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" sx={{ color: '#fff' }} />} aria-label="breadcrumb">
            <Link underline="hover" sx={{ color: '#fff' }} color='inherit' href='/account-manager-details'>Account Manager Details</Link>
        </Breadcrumbs>
    </Stack>
)

export default function AccountManegerDetails() {
    const dispatch = useDispatch()
    // state
    const getProfileSelector = useSelector(state => state.myProfile)
    const { data, loading } = getProfileSelector


    const handleRefresh = () => {
        dispatch(myProfileAction())
    }

    return (
        <>
            {/* <Stack direction='row' justifyContent="center" >
                <Typography variant='h5' fontFamily='Gantari' color='#1D2524' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='33px'>Account Manager Details</Typography>
            </Stack>
            <Grid container xs={12} sx={{ width: "100%", height: "70%", display: "flex", justifyContent: "center" }} >

                <Card elevation={0} sx={{ my: 6, width: "50vw", border: "1px solid #000", borderRadius: "10px", padding: "30px" }}>
                    <CardContent>
                        <Avatar sx={{ bgcolor: "transparent", border: "4px solid black", my: 2, width: "100px", height: "100px" }}><img src={data?.m_image} width="100px" /></Avatar>
                        <Stack sx={{ my: 2 }}>
                            <Typography fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='400' fontSize='14px' lineHeight='24px'>Manager Name</Typography>
                            <Typography variant='h5' sx={{ fontWeight: 600 }} fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='29px'>{data?.m_name || "--"}</Typography>
                        </Stack>

                        <Stack sx={{ my: 2 }}>
                            <Typography fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='400' fontSize='14px' lineHeight='24px'>Email Address</Typography>
                            <Stack direction="row" alignItems="center" gap='10px'>
                                <Typography variant='h5' sx={{ fontWeight: 600 }} fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='29px'>{data?.m_email || "--"}</Typography>
                                {data &&
                                    <img
                                        src={emailLink}
                                        width="16px"
                                        alt="Email"
                                        onClick={() => window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${data.m_email}`,
                                            "_blank")}
                                    />
                                }
                            </Stack>
                        </Stack>

                        <Stack sx={{ my: 2 }}>
                            <Typography fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='400' fontSize='14px' lineHeight='24px'>Contact Address</Typography>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography variant='h5' sx={{ fontWeight: 600 }} fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='29px'>{data?.m_mobile || "--"}</Typography>
                                <div style={{ display: "flex", justifyContent: "flex-end" }}>

                                    <a
                                        onClick={() => window.open(`tel:${data?.m_mobile}`,
                                            "_blank")}
                                    ><img src={CallIcon} width="40%" /></a>

                                    <a
                                        onClick={() => window.open(`https://wa.me/${data?.m_mobile}`,
                                            "_blank")}
                                    ><img src={WhatsAppIcon} width="40%" /></a>
                                </div>
                            </Stack>
                        </Stack>
                    </CardContent>
                </Card>
            </Grid> */}


            <Stack direction="row" justifyContent="center" sx={{ my: 3 }}>
  <Typography
    variant="h5"
    fontFamily="Gantari"
    color="#1D2524"
    fontStyle="normal"
    fontWeight={600}
    fontSize="24px"
    lineHeight="33px"
    textAlign="center"
  >
    Account Manager Details
  </Typography>
</Stack>

<Grid container justifyContent="center">
  <Grid item xs={12} sm={10} md={8} lg={6}>
    <Card
      elevation={0}
      sx={{
        my: 6,
        width: "100%",
        border: "1px solid #000",
        borderRadius: "10px",
        p: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <CardContent>
        <Stack alignItems="center" mb={2}>
          <Avatar
            sx={{
              bgcolor: "transparent",
              border: "4px solid black",
              width: 100,
              height: 100,
            }}
          >
            <img
              src={data?.m_image}
              width="100%"
              height="100%"
              style={{ borderRadius: "50%" }}
              alt="Manager"
            />
          </Avatar>
        </Stack>

        <Stack sx={{ my: 2 }}>
          <Typography fontSize="14px" color="#585858">
            Manager Name
          </Typography>
          <Typography
            variant="h6"
            fontWeight={600}
            fontSize="20px"
            color="#585858"
          >
            {data?.m_name || "--"}
          </Typography>
        </Stack>

        <Stack sx={{ my: 2 }}>
          <Typography fontSize="14px" color="#585858">
            Email Address
          </Typography>
          <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap">
            <Typography
              variant="h6"
              fontWeight={600}
              fontSize="20px"
              color="#585858"
              sx={{ wordBreak: "break-all" }}
            >
              {data?.m_email || "--"}
            </Typography>
            {data?.m_email && (
              <img
                src={emailLink}
                width="16px"
                alt="Email"
                onClick={() =>
                  window.open(
                    `https://mail.google.com/mail/?view=cm&fs=1&to=${data.m_email}`,
                    "_blank"
                  )
                }
                style={{ cursor: "pointer" }}
              />
            )}
          </Stack>
        </Stack>

        <Stack sx={{ my: 2 }}>
          <Typography fontSize="14px" color="#585858">
            Contact Address
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
            spacing={1}
          >
            <Typography
              variant="h6"
              fontWeight={600}
              fontSize="20px"
              color="#585858"
            >
              {data?.m_mobile || "--"}
            </Typography>
            <Stack direction="row" spacing={2}>
              {data?.m_mobile && (
                <>
                  <img
                    src={CallIcon}
                    alt="Call"
                    width="24"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      window.open(`tel:${data?.m_mobile}`, "_blank")
                    }
                  />
                  <img
                    src={WhatsAppIcon}
                    alt="WhatsApp"
                    width="24"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      window.open(`https://wa.me/${data?.m_mobile}`, "_blank")
                    }
                  />
                </>
              )}
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  </Grid>
</Grid>




        </>
    )
}
